var sellOut = "https://shopfront-cdn.tekoapis.com/static/7efaee58ad023c8f.svg";

export { sellOut as default };
